module.exports = __webpack_public_path__ + "img/bind4.1cfdef78.png";